module.exports = __webpack_public_path__ + "static/fomorian-e161db74dbab1bc701d2a9c4544cec8f.jpeg";